





































export default [













    
    
    
    
    
    
    
    '$65' ,
    '$50' ,
    '$65' ,
    '$85' ,
    '$100',
    '$70' ,
    '$55' ,
    '$50' ,
    '$40' ,
    '$95' ,
    
    '$40' ,
    '$35' ,
    '$35' ,
    '$65' ,
    '$65' ,
    '$55' ,
    '$70' ,
    '$80' ,
    '$60' ,
    '$30' ,
    
    '$85' ,
    '$65' ,
    '$65' ,
    '$60' ,
    '$65' ,
    '$65' ,
    '$60' ,
    '$65' ,
    '$65' ,
    '$50' ,
    
    '$65' ,
    '$65' ,
    '$65' ,
    '$40' ,
    '$40' ,
    '$65' ,
    '$50' ,
    '$50' ,
    
    '$65' ,
    '$50' ,
    '$55' ,
    '$130' ,
    '$85' ,
    '$65' ,
    '$60' ,
    '$75' ,
    '$40' ,
    '$65' 
];